import React, { FC, useEffect } from 'react';
import { useHistory } from 'react-router';

import { useUserAgent } from 'app/lib/user-agent';
import { createGaEvent, dispatchGaEvent } from 'app/packages/analytics';

import { DesktopLayout } from './components/DesktopLayout';
import { MobileLayout } from './components/MobileLayout';

export const Download: FC = () => {
  const { mobileOperationSystem, isMobile } = useUserAgent();
  const { location, replace } = useHistory();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const fromParam = urlParams.get('from');

    if (fromParam) {
      dispatchGaEvent(createGaEvent({ event: 'launchFrom', eventValue: fromParam }));
    }

    replace({ search: '' });
  }, []);

  return (
    <>
      {!isMobile && (
        <DesktopLayout />
      )}
      {isMobile && (
        <MobileLayout os={mobileOperationSystem} />
      )}
    </>
  );
};
